import {logger} from "./loggingService";
import axios from "axios";
import bearerAxios from "../helpers/bearerAxios";

const getRoofSquareData = async (account_id: string, source: string) => {
    return await bearerAxios.get(`${import.meta.env.VITE_PANDA_BASE_URL + 
        import.meta.env.VITE_GET_ROOF_SQUARE_API_URL!}?source=${source}&accountId=${account_id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            logger.error(error);
            return error;
        })
}

const getRoofSquarePricingAPIToken = async () => {
    try {
        const res = await axios.get(import.meta.env.VITE_EXCELSERVICES_TOKEN_API_URL!)
        return res.data.token;
    } catch (err) {
        return err
    }
}

const saveRoofSquare = async (payload: any) => {
    try {
        const response = await bearerAxios.post(
            import.meta.env.VITE_BASE_URL + import.meta.env.VITE_SAVE_ROOF_SQUARE_API_URL!,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    } catch (error) {
        logger.error(error);
        throw error;
    }
};


const getRoofSquarePricingData = async (token: string, stateValue: string, lowRoofSquare: number, normalRoofSquare: number) => {

    return await axios({
        method: 'post',
        url: `${import.meta.env.VITE_EXCELSERVICES_API_URL}`,
        data: {
            ExcelFileName: "Roofing Calculator",
            SheetName: "Roof Pricing",
            InputValues: [
                {"CellNumber": "C3", "CellValue": stateValue, "Type": "String"},
                {"CellNumber": "C4", "CellValue": "R", "Type": "String"},
                {"CellNumber": "C5", "CellValue": "Solar", "Type": "String"},
                {"CellNumber": "C6", "CellValue": "IKO", "Type": "String"},
                {"CellNumber": "C7", "CellValue": "Cambridge", "Type": "String"},
                {"CellNumber": "C8", "CellValue": lowRoofSquare, "Type": "String"},
                {"CellNumber": "C9", "CellValue": normalRoofSquare, "Type": "String"},
                {"CellNumber": "C10", "CellValue": 0, "Type": "String"},
                {"CellNumber": "C11", "CellValue": 0, "Type": "string"},
                {"CellNumber": "C12", "CellValue": 0, "Type": "string"},
                {"CellNumber": "H3", "CellValue": "Standard", "Type": "string"},
                {"CellNumber": "M3", "CellValue": "0", "Type": "string"},
                {"CellNumber": "R3", "CellValue": "Cash", "Type": "string"},
                {"CellNumber": "H4", "CellValue": "0", "Type": "string"},
                {"CellNumber": "H5", "CellValue": "0", "Type": "string"},
                {"CellNumber": "H6", "CellValue": null, "type": "string"},
                {"CellNumber": "H7", "CellValue": "Sales- Direct", "type": "string"}
            ],
            OutputCells: ["E6", "E7", "J4", "J5", "J6", "J7", "J8", "J9", "J10", "J11"]
        },
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
        .then((res) => {
            return{
                floorPrice:res.data.OutputValues[2].CellValue,
                minPrice:res.data.OutputValues[3].CellValue,
                standardPrice:res.data.OutputValues[3].CellValue,
                standardPlusOnePrice:res.data.OutputValues[7].CellValue,
            }


        })
        .catch((err) => {
            logger.error(err);
            return err
        })
}

export const roofSquareService = {
    getRoofSquareData,
    getRoofSquarePricingAPIToken,
    getRoofSquarePricingData,
    saveRoofSquare
}

